module.exports = __webpack_public_path__ + "assets/img/17946ccbc7fb9b9e07bba9e5ae5350ee.png";